import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await fetch('/api/auth/me', { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) { const data = await res.json(); setUser(data); }
      else { localStorage.removeItem('token'); }
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const refreshUser = fetchMe;

  const authFetch = useCallback(async (url, options = {}) => {
    const token = localStorage.getItem('token');
    // FormData bodies (file uploads) must NOT get a hardcoded Content-Type —
    // the browser needs to set 'multipart/form-data; boundary=...' itself.
    // Forcing 'application/json' here would silently break every upload,
    // since the server's multer parser can't read a multipart body sent
    // with the wrong Content-Type. Every current upload flow (Documents.js,
    // ImportAudit.js, AIWorkspace.js) works around this today by using raw
    // fetch() instead of authFetch() — this makes authFetch itself safe to
    // use for uploads too, instead of that workaround being load-bearing.
    const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
    const res = await fetch(url, {
      ...options,
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        ...(options.headers||{}),
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    });
    if (res.status === 401) { logout(); }
    return res;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, authFetch, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
